import React, { useEffect } from "react";
import * as classes from "./flowStepPhone.module.scss";
import { useForm } from "react-hook-form";
import TextInput from "@components/ui/textInput";
import SubmitButton from "@components/ui/submitButton";
import FlowStepContainer from "./flowStepContainer";

export default function FlowStepPhone({ stepNo, totalSteps, onDataSubmit, forTrial }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
    watch,
    setValue,
    setFocus,
  } = useForm({ mode: "onChange" });

  const phoneNumber = watch("phone");
  const onSubmit = (e) => {
    onDataSubmit(e);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFocus("phone");
    }, 500);

    return () => clearTimeout(timeout);
  }, [setFocus]);

  function* chunks(cs, input) {
    let rest = input;
    for (let i = 0; i < cs.length; ++i, rest.length > 0) {
      const head = rest.slice(0, cs[i]);
      yield head;
      rest = rest.slice(cs[i], rest.length);
    }
  }

  useEffect(() => {
    const keepDigits = (input) => input.replace(/[^\d]/g, "");
    const chunkPhone = (input) => Array.from(chunks([3, 3, 4], input));
    const formatPhone = (input) => {
      if (input === "+") return input;
      if (input === "+1") return "+1 ";
      if (input.slice(0, 3) === "+1 ") {
        return (
          "+1 " +
          chunkPhone(keepDigits(input.slice(3)).slice(0, 10))
            .filter((x) => x)
            .join(" ")
        );
      } else {
        return (
          "+1 " +
          chunkPhone(keepDigits(input).slice(0, 10))
            .filter((x) => x)
            .join(" ")
        );
      }
    };
    if (phoneNumber) {
      setValue("phone", formatPhone(phoneNumber));
    }
  }, [phoneNumber, setValue]);

  return (
    <FlowStepContainer
      stepNo={stepNo}
      totalSteps={totalSteps}
      title="What's your cell phone number?"
      innerCtnClass={classes.inner}
      subTitle={forTrial ? "Final step! We'll send a text message to verify your account." : null}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          tabIndex={1}
          type="text"
          required="required"
          placeholder="+1"
          label="Phone number (with country code)"
          errors={errors}
          {...register("phone")}
          v2={true}
        />
        <SubmitButton tabIndex={2} className={classes.btn} id={"phone-submit"}>
          Send Code
        </SubmitButton>
      </form>
    </FlowStepContainer>
  );
}
